import {
	Container,
	ContainerGutter,
	ReferenceBadge,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { huchaLinesColor } from '../../../../../../../../helpers/color-tokens';
import { StyledBalanceText } from '../../../../../shared/ui/styles';
import { HuchaRenovadoresLabel } from '../../../ui/hucha-renovadores-label';
import { Super100SymbolText, Super100Text } from '../../../ui/money-font-styles';

const MainContainer = styled(Container)`
	overflow: visible;
	padding-top: 18px;
	padding-left: 15px;
`;

const StyledC3Wrapper = styled.div`
	border: 2px solid ${huchaLinesColor};
	border-radius: 16px;
	position: relative;
	align-content: center;
	padding-left: var(--size-dynamic0130);
	padding-right: var(--size-dynamic0130);
	height: 160px;
`;

const StyledTextWrapper = styled(Container)`
	border-top: 2px solid ${huchaLinesColor};
	border-bottom: 2px solid ${huchaLinesColor};
	padding-top: 10px;
	padding-bottom: 10px;
	padding-left: 4px;
	padding-right: 4px;
	width: 250px;
`;

export const StyledReferenceBadge = styled(ReferenceBadge)`
	margin-top: 15px;
`;

export const PdfHuchaRenovadoresCardC3 = ({ DGTLabelInfo }: { DGTLabelInfo: boolean }) => {
	const badge = '2';

	return (
		<MainContainer stretchContent data-testid="pdf-c3-container">
			<StyledC3Wrapper>
				<HuchaRenovadoresLabel />
				<Container
					gutter={ContainerGutter.dynamic0100}
					verticalAlign="center"
					stretchContent
					horizontalAlign="center"
					data-testid="pdf-c3-inner-container"
					wrap="never"
				>
					<Container wrap="never" horizontalAlign="center">
						<Container wrap="never" verticalAlign="flex-end">
							<Super100Text color={TokenTextColor.inverted}>+1.000</Super100Text>
							<Super100SymbolText color={TokenTextColor.inverted}>{'€'}</Super100SymbolText>
						</Container>

						<StyledReferenceBadge variant="large">{badge.replace(/\.$/, '')}</StyledReferenceBadge>
					</Container>

					<StyledTextWrapper stretchContent verticalAlign="center" horizontalAlign="center">
						{DGTLabelInfo ? (
							<StyledBalanceText
								appearance={TokenTextAppearance.headline200}
								color={TokenTextColor.inverted}
								textAlign={TextAlignment.center}
							>
								para renovar tu coche y que las restricciones de movilidad no te limiten
							</StyledBalanceText>
						) : (
							<StyledBalanceText
								appearance={TokenTextAppearance.headline200}
								color={TokenTextColor.inverted}
								textAlign={TextAlignment.center}
							>
								La Excusa Oficial Volkswagen para renovar tu coche este año
							</StyledBalanceText>
						)}
					</StyledTextWrapper>
				</Container>
			</StyledC3Wrapper>
		</MainContainer>
	);
};
